import React from 'react';
import { ButtonLink } from '../../../../components/base/Button/Link';
import { concatClsx } from '../../../../helpers/classNames';
export var AuthTypeRedirectButton = function (_a) {
    var containerStyle = _a.containerStyle;
    var type = window.location.href.includes('sign-up') ? 'sign-in' : 'sign-up';
    return (React.createElement("div", { className: concatClsx('flex items-baseline', containerStyle) },
        React.createElement("p", null, type === 'sign-up' ? 'Not a member yet?' : 'Already have an account?'),
        React.createElement(ButtonLink, { ghost: true, type: "link", className: "ml-2 p-0 text-brand-orange h-auto", to: "../".concat(type) }, type === 'sign-up' ? 'Sign up' : 'Sign in')));
};
